const T_PREFIX = "privacy-policy";

export const privacyPolicyTrns = {
  title: `${T_PREFIX}.title`,

  introductionTitle: `${T_PREFIX}.introduction.title`,
  informationCollectionTitle: `${T_PREFIX}.information-collection.title`,
  personalInformationTitle: `${T_PREFIX}.personal-information.title`,
  financialInformationTitle: `${T_PREFIX}.financial-information.title`,
  technicalInformationTitle: `${T_PREFIX}.technical-information.title`,
  otherInformationTitle: `${T_PREFIX}.other-information.title`,
  sourcesInformationTitle: `${T_PREFIX}.sources-information-collection.title`,
  informationUsageTitle: `${T_PREFIX}.information-usage.title`,
  serviceProvisionTitle: `${T_PREFIX}.service-provision.title`,
  websiteImprovementTitle: `${T_PREFIX}.website-improvement.title`,
  communicationTitle: `${T_PREFIX}.communication.title`,
  rightsSecurityTitle: `${T_PREFIX}.rights-security-protection.title`,
  informationDisclosureTitle: `${T_PREFIX}.information-disclosure.title`,
  consentTitle: `${T_PREFIX}.consent.title`,
  businessPartnersTitle: `${T_PREFIX}.business-partners.title`,
  legalRequirementsTitle: `${T_PREFIX}.legal-requirements.title`,
  serviceProvidersTitle: `${T_PREFIX}.service-providers.title`,
  aggregatedInformationTitle: `${T_PREFIX}.aggregated-anonymized-information.title`,
  companySaleTitle: `${T_PREFIX}.sale-or-merger-company.title`,
  informationProtectionTitle: `${T_PREFIX}.information-protection.title`,
  personalRightsTitle: `${T_PREFIX}.personal-rights.title`,
  changesPolicyTitle: `${T_PREFIX}.changes-privacy-policy.title`,
  processChangesTitle: `${T_PREFIX}.process-making-changes.title`,
  identifyingNeedChangesTitle: `${T_PREFIX}.identifying-need-changes.title`,
  developingChangesTitle: `${T_PREFIX}.developing-changes.title`,
  internalApprovalTitle: `${T_PREFIX}.internal-approval.title`,
  informingUsersTitle: `${T_PREFIX}.informing-users.title`,
  importantAspectsChangesTitle: `${T_PREFIX}.important-aspects-changes.title`,
  updatedEffectiveDateTitle: `${T_PREFIX}.updated-effective-date.title`,
  significantChangesTitle: `${T_PREFIX}.significant-changes.title`,
  regularReviewTitle: `${T_PREFIX}.regular-review.title`,
  reviewFrequencyTitle: `${T_PREFIX}.review-frequency.title`,
  userFeedbackTitle: `${T_PREFIX}.user-feedback.title`,
  userActionsTitle: `${T_PREFIX}.user-actions.title`,
  regularReviewActionsTitle: `${T_PREFIX}.regular-review-actions.title`,
  inquiriesQuestionsTitle: `${T_PREFIX}.inquiries-questions.title`,
  consentToChangesTitle: `${T_PREFIX}.consent-to-changes.title`,
  additionalInformationTitle: `${T_PREFIX}.additional-information.title`,
};
